import React, { FC } from 'react';
import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import { Discount, FormModel } from '../../../../models/form/form';
import useFormSummary from './useFormSummary';
import { useIntl } from 'react-intl';
import { getText } from '../../../../utilities/CultureUtilities';

interface Props {
  form: FormModel;
  className: string;
  discount: Discount;
}

const FormSummary: FC<Props> = ({ form, discount, className }: Props) => {
  const { total, summary } = useFormSummary(form, discount);
  const topbar = document.querySelector('header.topbar');
  const { locale } = useIntl();

  if (summary.length == 0) return null;

  return (
    <div className={className}>
      <Card className={classNames('form-summary', { 'offset-topbar': topbar })}>
        <Card.Body className="options">
          {summary.map((field, index) => {
            return (
              <div className="option-group" key={`field-${index}`}>
                <div className="option-group-title">{getText(field.fieldName, locale)}</div>
                {field.options.map((option) => {
                  return (
                    <div
                      key={`payment-option-${option.value}`}
                      className="d-flex align-items-center justify-content-between option"
                    >
                      <div className="option-label">{getText(option.text, locale)}</div>
                      <div className="option-price">{(option.price / 100).toFixed(2)} $</div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </Card.Body>
        <Card.Footer className="total d-flex align-items-center justify-content-between">
          <div className="option-label">Total</div>
          <div className="option-price">{(total / 100).toFixed(2)} $</div>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default FormSummary;
